import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/warninglist.scss';

class WarningList extends PureComponent {
  render() {
    const { warnings } = this.props;

    const list = [];
    warnings.forEach((warning, index) => {
      list.push(
        <div key={index} className="warning-wrapper">
          <div className="number">{index + 1}</div>
          <div className="field">{warning.label}</div>
          <div className="warning">{warning.text}</div>
        </div>,
      );
    });

    return (
      <div className="warning-list">
        <div className="heading">Please review existing warnings before confirming submission.</div>
        {list}
      </div>
    );
  }
}

WarningList.propTypes = {
  warnings: PropTypes.array,
};

export default WarningList;
